import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CAT_CONFIG, SETTING_LABEL, SETTING_ICON, priceLabel, distLabel } from '../lib/data';
import StarRating from './StarRating';
import { useGoogleRating } from '../lib/useGoogleRating';

const FORMSPREE_BUGREPORT = 'xgopkbkk';

function Gallery({ cat }) {
  const [active, setActive] = useState(0);
  const count = 3;
  return (
    <div style={{ position: 'relative', background: cat.bg, height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
      <span style={{ fontSize: 72, userSelect: 'none' }}>{cat.emoji}</span>
      <div style={{ position: 'absolute', bottom: 10, left: 0, right: 0, display: 'flex', justifyContent: 'center', gap: 5 }}>
        {Array.from({ length: count }).map((_, i) => (
          <button key={i} onClick={() => setActive(i)}
            style={{ width: active === i ? 18 : 5, height: 5, borderRadius: 99, border: 'none', background: active === i ? cat.color : 'rgba(255,255,255,.5)', transition: 'all .2s', padding: 0, cursor: 'pointer' }} />
        ))}
      </div>
      {active > 0 && (
        <button onClick={() => setActive(a => a - 1)}
          style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', background: 'rgba(255,255,255,.85)', border: 'none', borderRadius: 99, width: 28, height: 28, fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>‹</button>
      )}
      {active < count - 1 && (
        <button onClick={() => setActive(a => a + 1)}
          style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'rgba(255,255,255,.85)', border: 'none', borderRadius: 99, width: 28, height: 28, fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>›</button>
      )}
      <span style={{ position: 'absolute', top: 10, right: 10, background: 'rgba(0,0,0,.4)', color: '#fff', fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 99 }}>📷 3</span>
    </div>
  );
}

function BugReportForm({ activityName, onClose }) {
  const [message, setMessage] = useState('');
  const [email, setEmail]     = useState('');
  const [status, setStatus]   = useState('idle');

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch(`https://formspree.io/f/${FORMSPREE_BUGREPORT}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ place: activityName, message, email }),
      });
      setStatus(res.ok ? 'success' : 'error');
    } catch {
      setStatus('error');
    }
  }

  if (status === 'success') {
    return (
      <div style={{ background: '#F0FFF4', border: '1px solid #BBF7D0', borderRadius: 14, padding: '20px 16px', textAlign: 'center' }}>
        <div style={{ fontSize: 28, marginBottom: 8 }}>✅</div>
        <div style={{ fontWeight: 700, color: '#166534', fontSize: 14 }}>Dziękujemy za zgłoszenie!</div>
        <div style={{ fontSize: 12, color: '#4ADE80', marginTop: 4 }}>Sprawdzimy i poprawimy jak najszybciej.</div>
        <button onClick={onClose}
          style={{ marginTop: 14, fontSize: 12, color: '#888', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}>
          Zamknij
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {/* Pre-filled place name */}
      <div>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#aaa', textTransform: 'uppercase', letterSpacing: .5, marginBottom: 4 }}>Miejsce</div>
        <div style={{ padding: '10px 12px', background: '#f5f5f5', borderRadius: 10, fontSize: 13, color: '#888', fontWeight: 600 }}>
          {activityName}
        </div>
      </div>

      {/* What's wrong */}
      <div>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#aaa', textTransform: 'uppercase', letterSpacing: .5, marginBottom: 4 }}>Co jest nie tak? *</div>
        <textarea
          required
          value={message}
          onChange={e => setMessage(e.target.value)}
          placeholder="np. zły adres, miejsce jest zamknięte, nieprawidłowe godziny..."
          style={{ width: '100%', padding: '10px 12px', borderRadius: 10, border: '1px solid #e5e5e5', fontSize: 13, fontFamily: 'inherit', minHeight: 80, resize: 'vertical', outline: 'none', boxSizing: 'border-box' }}
        />
      </div>

      {/* Email optional */}
      <div>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#aaa', textTransform: 'uppercase', letterSpacing: .5, marginBottom: 4 }}>Twój email (opcjonalnie)</div>
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="jeśli chcesz otrzymać odpowiedź"
          style={{ width: '100%', padding: '10px 12px', borderRadius: 10, border: '1px solid #e5e5e5', fontSize: 13, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }}
        />
      </div>

      {status === 'error' && (
        <div style={{ fontSize: 12, color: '#DC2626', background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 8, padding: '8px 12px' }}>
          Coś poszło nie tak. Spróbuj ponownie.
        </div>
      )}

      <div style={{ display: 'flex', gap: 8 }}>
        <button type="button" onClick={onClose}
          style={{ flex: 1, padding: '12px', borderRadius: 12, border: '1px solid #e5e5e5', background: '#fff', fontSize: 13, fontWeight: 700, color: '#888', cursor: 'pointer', fontFamily: 'inherit' }}>
          Anuluj
        </button>
        <button type="submit" disabled={status === 'sending'}
          style={{ flex: 2, padding: '12px', borderRadius: 12, border: 'none', background: '#EF4444', fontSize: 13, fontWeight: 700, color: '#fff', cursor: 'pointer', fontFamily: 'inherit', opacity: status === 'sending' ? .7 : 1 }}>
          {status === 'sending' ? 'Wysyłanie…' : 'Wyślij zgłoszenie'}
        </button>
      </div>
    </form>
  );
}

export default function DetailSheet({ activity, onClose, userLat, userLng }) {
  const { t } = useTranslation();
  const [showBugForm, setShowBugForm] = useState(false);

  const cat  = CAT_CONFIG[activity.category] || CAT_CONFIG.entertainment;
  const dist = distLabel(activity, userLat, userLng);
  const { rating: gRating, total: gTotal, loaded: gLoaded } = useGoogleRating(
    activity.id,
    activity.name,
    activity.city,
    activity.googlePlaceId || null
  );
  const mapsUrl = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent((activity.address || '') + ', ' + (activity.city || ''));

  if (!activity) return null;


  return (
    <div onClick={onClose}
      style={{ position: 'fixed', inset: 0, zIndex: 500, display: 'flex', flexDirection: 'column' }}>
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,.45)', backdropFilter: 'blur(3px)' }} />

      <div onClick={e => e.stopPropagation()}
        style={{ position: 'relative', marginTop: 'auto', background: '#fff', borderRadius: '22px 22px 0 0', maxHeight: '92vh', overflowY: 'auto', maxWidth: 480, width: '100%', marginLeft: 'auto', marginRight: 'auto' }}>

        {/* Handle + close */}
        <div style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 10, borderRadius: '22px 22px 0 0', padding: '11px 0 7px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 5 }}>
            <div style={{ width: 38, height: 4, borderRadius: 99, background: '#e5e5e5' }} />
          </div>
          <button onClick={onClose}
            style={{ position: 'absolute', top: 9, right: 14, background: '#f5f5f5', border: 'none', borderRadius: 99, width: 30, height: 30, fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888', cursor: 'pointer' }}>
            ✕
          </button>
        </div>

        <Gallery cat={cat} />

        <div style={{ padding: '16px 16px 40px', display: 'flex', flexDirection: 'column', gap: 16 }}>

          {/* Title */}
          <div>
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8, marginBottom: 5 }}>
              <h2 style={{ fontWeight: 800, fontSize: 19, color: '#111', lineHeight: 1.25, flex: 1 }}>{activity.name}</h2>
              <span style={{ background: cat.color, color: '#fff', fontSize: 11, fontWeight: 700, padding: '3px 9px', borderRadius: 99, flexShrink: 0, marginTop: 2 }}>{cat.label}</span>
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 12, color: '#999' }}>
              <span>{SETTING_ICON[activity.setting]} {SETTING_LABEL[activity.setting]}</span>
              <span style={{ width: 3, height: 3, borderRadius: 99, background: '#ddd', display: 'inline-block' }} />
              <span>📍 {dist}</span>
            </div>
          </div>

          {/* Ratings */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>

            {/* Google rating */}
            <div style={{ fontSize: 13, color: '#555' }}>
              {gLoaded
                ? gRating
                  ? '🌐 Google: ⭐ ' + gRating + ' (' + gTotal + ' opinii)'
                  : '🌐 Google: brak danych'
                : '🌐 Google: ...'}
            </div>

            {/* KidzMap rating — handled inside StarRating */}
            <StarRating activityId={activity.id} />

          </div>

          <div style={{ height: 1, background: '#f0f0f0' }} />
          {/* Info tiles */}
          <div style={{ display: 'flex', gap: 7 }}>
            {[
              { icon: '👶', label: t('detail.age'),   value: `${activity.ageMin}–${activity.ageMax} lat` },
              { icon: '💰', label: t('detail.price'),  value: priceLabel(activity), accent: activity.priceType === 'free' ? '#4CAF50' : null },
              { icon: '🕐', label: t('detail.hours'),  value: activity.openingHours },
            ].map(({ icon, label, value, accent }) => (
              <div key={label} style={{ flex: 1, background: '#F8F7F5', borderRadius: 11, padding: '9px 10px' }}>
                <div style={{ fontSize: 10, color: '#aaa', marginBottom: 2 }}>{icon} {label}</div>
                <div style={{ fontSize: 12, fontWeight: 700, color: accent || '#222', lineHeight: 1.3 }}>{value}</div>
              </div>
            ))}
          </div>

          {/* Description */}
          <div>
            <h3 style={{ fontWeight: 700, fontSize: 14, color: '#333', marginBottom: 8 }}>{t('detail.about')}</h3>
            <p style={{ fontSize: 13, color: '#666', lineHeight: 1.6 }}>{activity.description}</p>
          </div>

          {/* Tags */}
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {activity.tags.map(tag => (
              <span key={tag} style={{ background: cat.bg, color: cat.color, fontSize: 12, fontWeight: 700, padding: '4px 10px', borderRadius: 99 }}>#{tag}</span>
            ))}
          </div>

          <div style={{ height: 1, background: '#f0f0f0' }} />

          {/* Address */}
          <div>
            <h3 style={{ fontWeight: 700, fontSize: 14, color: '#333', marginBottom: 8 }}>{t('detail.location')}</h3>
            <a href={mapsUrl} target="_blank" rel="noreferrer"
              style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', background: '#F8F7F5', borderRadius: 14 }}>
              <div style={{ width: 36, height: 36, borderRadius: 12, background: '#FFF3E0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 }}>🗺️</div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#222' }}>{activity.address}</div>
                <div style={{ fontSize: 12, color: '#999', marginTop: 1 }}>{activity.city} &middot; Otwórz w mapach</div>
              </div>
            </a>
          </div>

          <div style={{ height: 1, background: '#f0f0f0' }} />

          {/* Contact */}
          <div>
            <h3 style={{ fontWeight: 700, fontSize: 14, color: '#333', marginBottom: 10 }}>{t('detail.contact')}</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <a href={`tel:${activity.phone}`}
                style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', background: '#F8F7F5', borderRadius: 14, textDecoration: 'none' }}>
                <div style={{ width: 36, height: 36, borderRadius: 12, background: '#E8F5E9', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>📞</div>
                <div>
                  <div style={{ fontSize: 11, color: '#aaa', marginBottom: 1 }}>{t('detail.phone')}</div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#222' }}>{activity.phone}</div>
                </div>
              </a>
              <a href={activity.website} target="_blank" rel="noreferrer"
                style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', background: '#F8F7F5', borderRadius: 14, textDecoration: 'none' }}>
                <div style={{ width: 36, height: 36, borderRadius: 12, background: '#E3F2FD', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>🌐</div>
                <div>
                  <div style={{ fontSize: 11, color: '#aaa', marginBottom: 1 }}>{t('detail.website')}</div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#222' }}>{t('detail.visitWebsite')}</div>
                </div>
              </a>
            </div>
          </div>

          {/* CTA buttons */}
          <div style={{ display: 'flex', gap: 8 }}>
            <a href={`tel:${activity.phone}`}
              style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: 13, borderRadius: 13, background: '#F8F7F5', color: '#333', fontWeight: 700, fontSize: 13, textDecoration: 'none', border: '2px solid #eee' }}>
              {t('detail.plan')}
            </a>
            <a href={activity.website} target="_blank" rel="noreferrer"
              style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: 13, borderRadius: 13, background: cat.color, color: '#fff', fontWeight: 700, fontSize: 13, textDecoration: 'none' }}>
              {t('detail.go')}
            </a>
          </div>

          <div style={{ height: 1, background: '#f0f0f0' }} />

          {/* Bug report */}
          {!showBugForm ? (
            <button
              onClick={() => setShowBugForm(true)}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '10px', borderRadius: 12, border: '1px solid #fee2e2', background: '#fff', color: '#EF4444', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
              🚩 Zgłoś błąd w danych
            </button>
          ) : (
            <BugReportForm activityName={activity.name} onClose={() => setShowBugForm(false)} />
          )}

        </div>
      </div>
    </div>
  );
}